import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

// Themed textarea — same brand tokens as Input (grey-200 border, green focus ring, control radius).
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid = false, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cn(
        "w-full min-h-[80px] rounded-control border bg-white px-3.5 py-2.5 text-[14px] text-grey-800 outline-none transition-colors",
        "placeholder:text-grey-400 focus-visible:outline-none focus-visible:ring-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        invalid
          ? "border-red focus-visible:border-red focus-visible:ring-red-border"
          : "border-grey-200 focus-visible:border-green focus-visible:ring-green",
        className,
      )}
      {...props}
    />
  );
});
